<template>
  <div class="template-connected">
    <div id="container">
      <b-modal
        title="Ajout d'un document"
        hide-footer
        centered
        size="xl"
        height="100%"
        header-bg-variant="warning"
        header-text-variant="white"
        v-model="adddoc"
      >
        <div class="block-flat">
          <iframe
            class="add-doc"
			scrolling="no"
			sandbox="allow-same-origin allow-scripts allow-popups allow-forms" 
            src="https://nextcloud.clicmap.fr/index.php/s/o9f7nfknMZarxN3"
          ></iframe>
        </div>
      </b-modal>
      <div class="block-flat document">
        <div class="block-content h-100">
          <fieldset>
            <legend>
              Visualisation des documents
              <div class="btn btn-primary ml-5 mb-2" @click="adddoc = true">
                Ajouter un document
              </div>
            </legend>
          </fieldset>
          <iframe
			class="visu-doc"
			scrolling="no"
			sandbox="allow-same-origin allow-scripts allow-popups allow-forms" 
            src="https://nextcloud.clicmap.fr/index.php/s/qnf2XYFrf74ApWw"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import historyTimeline from "../components/historyTimeline.vue";
export default {
  data: () => ({
    adddoc: false,
  }),
};
</script>

<style></style>
